import * as React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { PoshSelectRadioListItem } from "../../../misc/components/PoshSelectListItem";
import { faSignOut, faPlay } from "@fortawesome/free-solid-svg-icons";

interface P230HomeSpirometryNavigateProps {
    onComplete: (url?: string) => void;
    analysisSetId?: string;
}


export const P230HomeSpirometryNavigate = ({ onComplete, analysisSetId }: P230HomeSpirometryNavigateProps) => {
    const location = useLocation();
    const [navigateOptions, setNavigateOptions] = React.useState<any[]>([
        {
            id: 'option_liveTesting',
            icon: faPlay,
            title: 'Start now',
            description: "Navigate immediately to the live testing screen if you are ready to begin.",
            checked: false,
        },
        {
            id: 'option_exit',
            icon: faSignOut,
            title: 'Begin later',
            description: `Begin live testing at a later time. You can access this session from the Sessions screen`,
            checked: false,
        }]);

    const onSelect = (option: any) => {
        const updated = navigateOptions.map(a => ({
            ...a,
            checked: a.id === option.id ? true : false,
        }));

        setNavigateOptions(updated);
    }

    const onNext = () => {
        if (navigateOptions.find(x => x.checked).id === "option_liveTesting") {
            onComplete(analysisSetId);
        } else {
            onComplete();
        }
    }

    return (
        <>
            <div className="modal-body">
                <div className="row">
                    <div className="col-md-12">
                        <h2 className="text-primary">Device Configured</h2>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <p className="text-info">The device has been configured successfully, you can now start live testing now or begin at a later time.</p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <ul className="posh-select">
                            {navigateOptions.map(a => (
                                <PoshSelectRadioListItem
                                    key={a.id}
                                    id={a.id}
                                    title={a.title}
                                    description={a.description}
                                    icon={a.icon}
                                    isChecked={a.checked}
                                    onChange={() => onSelect(a)}
                                />))}
                        </ul>
                    </div>
                </div>
            </div>
            <div className="modal-footer">
                <button className="btn btn-primary" disabled={navigateOptions.filter(x => x.checked).length === 0} onClick={onNext}>Next</button>
            </div>
        </>
    );
}
